// The sign-in token itself lives in an HttpOnly cookie. All the page keeps is
// this flag — not a secret — so a visitor who never signed in doesn't cost a
// "who am I" request (and a 401) on every page load.
const SIGNED_IN_KEY = "shuwa_signed_in";

// Where the token used to be kept. Read once to move a returning visitor's
// session into the cookie, then removed for good.
const LEGACY_TOKEN_KEY = "shuwa_token";

export const isMarkedSignedIn = () => localStorage.getItem(SIGNED_IN_KEY) === "1";
export const markSignedIn = () => localStorage.setItem(SIGNED_IN_KEY, "1");
export const forgetSignedIn = () => localStorage.removeItem(SIGNED_IN_KEY);

export function takeLegacyToken() {
  const token = localStorage.getItem(LEGACY_TOKEN_KEY);
  if (token) localStorage.removeItem(LEGACY_TOKEN_KEY);
  return token;
}
